import _ from 'lodash';

import {connect, reducerAndActionsFor, createStore} from './redux/helpers/helpers';
import {logIn, logOut/*, signUp, updateMyAccount*/} from './redux/reducers/session/session-reducer';
import appsData from './apps-data';

import React from 'react';

import Page from './components/page/page';
import Logo from './components/logo/logo';
import Header from './components/header/header';
import AppWrapper from './components/app-wrapper/app-wrapper';

import {Component, className} from 'henrybuilt-react-library';

global.NODE_ENV = process.env.NODE_ENV;
global.API_DOMAIN = process.env.REACT_APP_API_DOMAIN;

//WARNING this can cause babel-polyfill issue in po-website
require('henrybuilt-js-library');

var lib = window.lib;

import getCookieDomain from './cookie-domain';

export {
  React, Component,
  Page, Logo, AppWrapper, Header,

  connect, reducerAndActionsFor, createStore,
  logIn, logOut,

  appsData, className, lib, _, getCookieDomain
};
